import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("aero_token", data.access_token);
      localStorage.setItem("aero_user", JSON.stringify(data.user));
      toast.success(`Welcome back, ${data.user.name || "there"}!`);
      navigate(data.user.role === "pilot" ? "/pilot" : "/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen flex flex-col bg-muted/30">
      <div className="px-5 md:px-8 py-6">
        <Link to="/" data-testid="back-home-link" className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:text-accent transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back to AeroAcres
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-5 pb-12">
        <div className="w-full max-w-md bg-card rounded-3xl border border-border shadow-card p-8 md:p-10">
          <div className="h-14 w-14 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center mb-6">
            <Lock className="h-6 w-6" />
          </div>
          <h1 className="font-display text-3xl text-primary font-bold">Sign in</h1>
          <p className="text-sm text-muted-foreground mt-2">Admins manage the business · Pilots see their assigned jobs.</p>

          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-xs font-semibold uppercase tracking-wider text-primary/70">Email</Label>
              <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-12 rounded-xl bg-background" placeholder="admin@aeroacres.com" />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs font-semibold uppercase tracking-wider text-primary/70">Password</Label>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-12 rounded-xl bg-background" placeholder="••••••••" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full h-12 rounded-xl bg-primary hover:bg-secondary text-primary-foreground font-semibold">
              {loading ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Signing in...</> : "Sign in"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
